import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage
import floorplanReducer from './floorplanSlice';
import visualizerReducer from './visualizerSlice';

// Persist config for floorplan slice (localStorage - long-term cache)
const floorplanPersistConfig = {
  key: 'floorplan',
  storage: storage, // localStorage
  whitelist: ['floorplans', 'locations', 'elevations', 'rooms', 'steps', 'combinedFloorplans', 'dataLoaded'], // Only persist data, not loading/error states
};

// Persist config for visualizer slice (localStorage)
const visualizerPersistConfig = {
  key: 'visualizer',
  storage: storage, // localStorage
  whitelist: ['stepSelections', 'currentStepIndex', 'activeFloorplanId', 'activeElevation', 'activeScene', 'activeSteps', 'completedStepIndices', 'sceneSelStrings'], // Persist user progress
};

// Create persisted reducers
const persistedFloorplanReducer = persistReducer(floorplanPersistConfig, floorplanReducer);
const persistedVisualizerReducer = persistReducer(visualizerPersistConfig, visualizerReducer);

// Configure Store
const store = configureStore({
  reducer: {
    floorplan: persistedFloorplanReducer,
    visualizer: persistedVisualizerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/PURGE'],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);

// Export store
export default store;
